import { TeacherPage } from '@asset/enum/page';
import {
  CheckTargetListPageQuery,
  TotalStudyStatusPageQuery,
} from '@asset/type/study-status';
import qs from 'qs';
import { ParsedUrlQuery } from 'querystring';
import { UrlObject } from 'url';

export const STUDY_MATERIAL_SPREAD_SHEET_URL_PREFIX =
  '/manage/material/spread-sheet/';
export const MANAGE_DASHBOARD_URL_PREFIX = '/manage/dashboard/';
export const MANAGE_STUDY_STATUS_LIST_URL_PREFIX = '/manage/study-status-list/';

export const getManageStudyMaterialSpreadSheetUrlObject = (
  materialId: number,
  query?: {
    editMode?: boolean;
  } | null,
): UrlObject => {
  const urlString = `${STUDY_MATERIAL_SPREAD_SHEET_URL_PREFIX}${materialId}`;
  return { pathname: urlString, query: query };
};

export const getManageCreditPageUrlObject = (studentId: number): UrlObject => {
  const urlString = `${MANAGE_DASHBOARD_URL_PREFIX}${TeacherPage.CREDITS}/${studentId}`;
  return { pathname: urlString };
};

export const getManageTotalStudyStatusListPageUrlObject = (
  query?: TotalStudyStatusPageQuery,
): UrlObject => {
  const urlString = `${MANAGE_STUDY_STATUS_LIST_URL_PREFIX}total`;
  const _query = qs.parse(
    qs.stringify(query, {
      skipNulls: true,
      arrayFormat: 'comma',
      encodeValuesOnly: true,
    }),
  );
  return { pathname: urlString, query: _query as ParsedUrlQuery };
};

export const getManageCheckTargetListPageUrlObject = (
  query?: CheckTargetListPageQuery,
): UrlObject => {
  const urlString = `${MANAGE_STUDY_STATUS_LIST_URL_PREFIX}check-target`;
  const _query = qs.parse(
    qs.stringify(query, {
      skipNulls: true,
      arrayFormat: 'comma',
      encodeValuesOnly: true,
    }),
  );
  return { pathname: urlString, query: _query as ParsedUrlQuery };
};

// TODO: 컨텐츠 에디터 페이지 이동 함수
// export const getContentsEditPageUrlObject = (
//   materialId: number,
//   query: {
//     pageId: number;
//   },
// ): UrlObject => {
//   const urlString = `/manage/material/edit/${materialId}`;
//   return { pathname: urlString, query: query };
// };

export const getManageConsultationPageUrlObject = (
  studentId: number,
): UrlObject => {
  const urlString = `${MANAGE_DASHBOARD_URL_PREFIX}${TeacherPage.CONSULTATION}/${studentId}`;
  return { pathname: urlString };
};

export const getManageStudyCalendarPageUrlObject = (
  studentId: number,
  query?: {
    date?: string; // YYYY-MM-DD 형식
    instanceId?: number;
  } | null,
): UrlObject => {
  const urlString = `${MANAGE_DASHBOARD_URL_PREFIX}${TeacherPage.STUDY_CALENDAR}/${studentId}`;

  if (!query) {
    return { pathname: urlString };
  }

  const _query = qs.parse(
    qs.stringify(query, {
      skipNulls: true,
      encodeValuesOnly: true,
    }),
  );

  return { pathname: urlString, query: _query as ParsedUrlQuery };
};
